import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'

import { useDeleteRetentionPolicyMutation } from '../../../store/account/account'
import { Modal } from '../../../components/Modal/Modal'
import { RetentionPolicy } from '../../../models/RetentionPolicy'

interface DeleteUserModalProps {
  policy?: RetentionPolicy
  show: boolean
  onHide: () => void
}

export const DeletePolicyModal: React.FC<DeleteUserModalProps> = ({ policy, show, onHide }) => {
  const accountId = useAppSelector(selectAccountId)
  const [deletePolicy, deletePolicyResult] = useDeleteRetentionPolicyMutation()
  const handleDeletePolicy = async () => {
    if (policy) {
      deletePolicy({ accountId: accountId, policyId: policy.id })
    }
  }

  useEffect(() => {
    if (deletePolicyResult.isSuccess) {
      onHide()
    }
  }, [deletePolicyResult])

  if (!policy) {
    return null
  }

  const body = (
    <Container>
      <Row className='pb-3'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>Delete Data Retention Policy</h4>
        </Col>
      </Row>
      <Row className='pb-4'>
        <Col className='p-0'>
          <div className='paragraph-medium'>
            Are you sure you want to delete Data Retention Policy <b>{policy.id}</b> ?
          </div>
        </Col>
      </Row>
      <Row></Row>
    </Container>
  )
  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={body}
      showFooterActions={true}
      onFooterPrimaryAction={handleDeletePolicy}
      footerPrimaryActionLoading={deletePolicyResult.isLoading}
      footerPrimaryActionTitle='Delete'
      footerPrimaryActionButtonVariant='danger'
    ></Modal>
  )
}
